<jb-error [showErrorIf]="!mainContent">
  Sorry, page did not load. Please, reload the page.
</jb-error>
<form
  class="mb4"
  jbFocusInvalid
  (ngSubmit)="submitReceipt()"
  [formGroup]="submitReceiptForm"
  #templateFormReference="ngForm"
  novalidate
  *ngIf="!(isSubmitted$ | async)"
>
  <div class="jb-grid">
    <div class="dn col-1-l db-l"></div>
    <div class="col-10-l bt b--light-gray"></div>
  </div>
  <div class="jb-grid">
    <div class="dn col-1-l db-l"></div>
    <section class="col-5-m col-4-l">
      <jb-form-field-container class="w-100 mt5" type="primary">
        <jb-input-label>
          {{ mainContent.firstNameField.label }}
        </jb-input-label>
        <input
          jbInput
          formControlName="firstNameField"
          class="input-height-override no-flying-focus"
          type="text"
        />
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && firstNameField.invalid
          "
        >
          {{ mainContent.firstNameField.validationLabels.required }}
        </jb-error>
      </jb-form-field-container>

      <jb-form-field-container class="w-100 mt3" type="primary">
        <jb-input-label> {{ mainContent.lastNameField.label }} </jb-input-label>
        <input
          jbInput
          formControlName="lastNameField"
          class="input-height-override no-flying-focus"
          type="text"
        />
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && lastNameField.invalid
          "
        >
          {{ mainContent.lastNameField.validationLabels.required }}
        </jb-error>
      </jb-form-field-container>

      <div class="w-100 mt4">
        <label class="dib lh-title pb2 charcoal f6">{{
          mainContent.flightDateField.label
        }}</label>
        <div
          class="flex"
          formGroupName="flightDateField"
          tabindex="0"
          aria-describedby="birthdayErrorMessage"
        >
          <div class="dib w-40 mr2">
            <jb-select
              placeholder="Month"
              formControlName="month"
              visibleItemsBeforeScrolling="4"
              class="monthSelector"
              [ngClass]="{
                'jb-invalid':
                  templateFormReference.submitted &&
                  templateFormReference.errors?.dateInvalid
              }"
            >
              <jb-select-option
                *ngFor="let item of months"
                [name]="item.label"
                [value]="item.value"
              >
              </jb-select-option>
            </jb-select>
          </div>
          <div class="days dib w-30 mr2">
            <jb-select
              placeholder="Day"
              formControlName="day"
              visibleItemsBeforeScrolling="4"
              class="daySelector"
              [ngClass]="{
                'jb-invalid':
                  templateFormReference.submitted &&
                  templateFormReference.errors?.dateInvalid
              }"
            >
              <jb-select-option
                *ngFor="let item of days"
                [name]="item.label"
                [value]="item.value"
              ></jb-select-option>
            </jb-select>
          </div>
          <div class="years dib w-30">
            <jb-select
              placeholder="Year"
              formControlName="year"
              visibleItemsBeforeScrolling="4"
              class="yearSelector"
              [ngClass]="{
                'jb-invalid':
                  templateFormReference.submitted &&
                  templateFormReference.errors?.dateInvalid
              }"
            >
              <jb-select-option
                *ngFor="let item of years"
                [name]="item.label"
                [value]="item.value"
              >
              </jb-select-option>
            </jb-select>
          </div>
        </div>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && flightDateField.invalid
          "
        >
          {{ mainContent.flightDateField.validationLabels.required }}
        </jb-error>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted &&
            templateFormReference.errors?.dateInvalid
          "
        >
          {{
            templateFormReference.errors?.displayUnderMinMessage
              ? mainContent.flightDateField.validationLabels.underMin ||
                mainContent.flightDateField.validationLabels.invalid
              : mainContent.flightDateField.validationLabels.invalid
          }}
        </jb-error>
      </div>

      <jb-form-field-container class="w-100 mt3" type="primary">
        <jb-input-label>
          {{ mainContent.confirmationCodeField.label }}
        </jb-input-label>
        <input
          jbInput
          formControlName="confirmationCodeField"
          class="input-height-override no-flying-focus"
          type="text"
        />
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted &&
            confirmationCodeField.errors?.required
          "
        >
          {{ mainContent.confirmationCodeField.validationLabels.required }}
        </jb-error>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted &&
            !confirmationCodeField.errors?.required &&
            (confirmationCodeField.errors?.maxlength ||
              confirmationCodeField.errors?.minlength ||
              confirmationCodeField.invalid)
          "
        >
          {{ mainContent.confirmationCodeField.validationLabels.invalid }}
        </jb-error>
      </jb-form-field-container>

      <div class="mt3 w-100">
        <jb-form-field-container type="primary">
          <jb-input-label>{{ mainContent.emailField.label }}</jb-input-label>
          <input
            jbInput
            formControlName="emailField"
            class="no-flying-focus input-height-override"
            type="email"
            maxlength="320"
          />
          <jb-error
            [showErrorIf]="
              templateFormReference.submitted && emailField.errors?.required
            "
          >
            {{ mainContent.emailField.validationLabels.required }}
          </jb-error>
          <jb-error
            [showErrorIf]="
              templateFormReference.submitted &&
              emailField.invalid &&
              !emailField.errors?.required
            "
          >
            {{ mainContent.emailField.validationLabels.invalid }}
          </jb-error>
        </jb-form-field-container>
        <span class="dib lh-title pt2 pl3 charcoal f6">{{
          mainContent.emailField.description
        }}</span>
      </div>

      <button
        class="w-100-important items-center mt-two-half"
        jbButton
        theme="ctaPrimary"
        aria-disabled="false"
      >
        {{ mainContent.submitCTA.label }}
      </button>
    </section>
  </div>
</form>

<section class="jb-grid mb3" *ngIf="submissionSucceeded$ | async">
  <div class="dn col-1-l db-l mt5"></div>
  <section
    class="flex flex-wrap col-4-s col-10-m col-10-l bt b--light-gray pt5"
  >
    <h3 class="w-100">{{ success.title }}</h3>
    <p class="col-10-m col-10-l lh-copy">{{ success.content }}</p>
  </section>
</section>

<section class="jb-grid mb3" *ngIf="submissionFailed$ | async">
  <div class="dn col-1-l db-l mt5"></div>
  <section
    class="flex flex-wrap col-4-s col-10-m col-10-l bt b--light-gray pt5"
  >
    <h3 class="w-100">{{ failure.title }}</h3>
    <p class="col-10-m col-10-l lh-copy">{{ failure.content }}</p>
  </section>
</section>
